<template id="modal-template">
    <transition v-if="show" name="modal" appear>
        <div class="modal-container modal-container--view-image">
            <div class="modal-wrapper">
                <div class="modal">
                    <div class="modal__body">
                        <div class="interior-modal">
                            <div class="interior-modal__left">
                                <!-- 이미지 슬라이드 -->
                                <div class="view-image-container">
                                    <div class="swiper-container">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide">
                                                <div class="view-image">
                                                    <div class="view-image__thumbnail">
                                                        <span class="view-image__thumbnail-image" :style="{ backgroundImage: `url('${portfolio.spaces[selectedIndex].afterImage}')`}"></span>
                                                        <!-- <img :src="`/${content.image.path}`"> -->
                                                    </div>
                                                    <span class="view-image__thumb-image"></span>
                                                </div>
                                            </div>
                                            <div class="swiper-slide">
                                                <div class="view-image">
                                                    <div class="view-image__thumbnail">
                                                        <span class="view-image__thumbnail-image" :style="{ backgroundImage: `url('${portfolio.spaces[selectedIndex].afterImage}')`}"></span>
                                                        <!-- <img :src="`/${content.image.path}`"> -->
                                                    </div>
                                                    <span class="view-image__thumb-image"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="view-image-container__prev" @click="prev()"></div>
                                    <div class="view-image-container__next" @click="next()"></div>
                                </div>
                            </div>
                            <div class="interior-modal__right">
                                <div class="interior-modal__buttons">
                                    <!-- 버튼 활성화 서브클래스: button--active -->
                                    <button class="button button--scrap button-active" @click="bookmarkContent">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <path fill-rule="evenodd" stroke-width="2.2px" stroke-linecap="butt" stroke-linejoin="round" fill="none" d="M22.100,14.100 L4.100,28.100 L4.100,4.100 L22.100,4.100 L22.100,28.100 L13.100,22.100 "></path>
                                        </svg>
                                        <span class="blind">스크랩</span>
                                    </button>
                                    <button class="button button--close" type="button" @click="close()"></button>
                                </div>
                                <div class="interior-modal__thumb">
                                    <!-- 연관이미지 -->
                                    <ul class="slide-thumbnail-container">
                                        <!-- 이미지 비어있어도 썸네일 블록 기본 10개 출력 -->
                                        <li v-for="(space, index) in portfolio.spaces" :key="index">
                                            <!-- 썸네일 슬라이드 활성화 애트리뷰트 aria-pressed="true" -->
                                            <div role="button" :aria-pressed="selectedIndex == index" @click="selectedIndex = index;">
                                                <span class="thumbnail">
                                                    <span class="img" :style="{ backgroundImage: `url('${space.afterImage}')` }"></span>
                                                </span>
                                                <span class="thumb"></span>
                                            </div>
                                        </li>
                                        <li v-for="(item, index) in 10-portfolio.spaces.length" :key="index">
                                            <div role="button" aria-pressed="false">
                                                <span class="thumbnail"></span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="interior-modal__link">
                                    <a class="button button--primary" :href="`/portfolio/resident/${portfolio._id}`">
                                        <span>현재 사진 포함 전체 인테리어</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8.5px" height="15.5px">
                                            <path fill-rule="evenodd"  stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="round" stroke-linejoin="round" fill="none" d="M1.500,1.500 L7.500,7.500 L1.500,13.500 "/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                            <div class="interior-modal__bottom">
                                <ul class="interior-list__tags">
                                    <li class="interior-list__tag" v-for="tag in portfolio.spaces[selectedIndex].tags" :key="tag"><span>#{{tag}}</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="modal__foot modal__foot-no-border">
                        <div class="modal__buttons modal__buttons--narrow">
                            <a class="button button--border-primary" href="" onclick="return false;" @click="close()"><span>쇼핑계속하기</span></a>
                            <a class="button button--primary" href="/mypage/cart"><span>장바구니 가기</span></a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
export default {
    data(){
        return {
            show: false,

            portfolio: null,
            selectedIndex: null
        }
    },
    mounted() {
        this.init2();
    },
    methods: {
        open(){
            this.show = true;
            this.selectedIndex = this.portfolio.spaceIndex;
        },
        close(){
            this.show = false;
        },
        prev(){
            if(0 < this.selectedIndex) this.selectedIndex--;
        },
        next(){
            if(this.selectedIndex < this.portfolio.spaces.length) this.selectedIndex++;
        },
        async bookmarkContent() {
            try{
                if(!this.payload) throw new Error("로그인이 필요한 기능입니다.");
            }
            catch(error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        init2: function(){
            this.$nextTick(function () {
                var slide = new Swiper ('.view-image-container .swiper-container', {
                    centeredSlides: true,
                    spaceBetween : 0,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    speed: 500,
                    loop: false,
                    navigation: {
                        nextEl: '.view-image-container__next',
                        prevEl: '.view-image-container__prev'
                    },
                });
            })
        },
    }
}
</script>

<style lang="css" scoped>
</style>
